(function() {
  "use strict";

  angular
    .module("rms.common")
    .directive("rmsSkillsetManager", rmsSkillsetManager);

  function rmsSkillsetManager(lodash, $document, $timeout) {
    return {
      restrict: "E",
      require: ["ngModel"],
      scope: {
        options: "=",
        refresh: "=?",
        readonly: "=?",
        hasError: "=?",
        errorMessage: "=?"
      },
      controller: rmsSkillsetManagerCtrl,
      controllerAs: "vm",
      bindToController: true,
      templateUrl: "common/app/components/skillset-manager",
      link: {
        post: function(scope, elem, attr, ctrl) {
          var vm = scope.vm;
          var ngModelCtrl = ctrl[0];

          init();

          // scope.$watch(function (scope) {
          //     return scope.vm.state.filteredSkills;
          // }, handleWatch, true);

          function init() {
            ngModelCtrl.$formatters.push(function(value) {
              return value.map(function(item) {
                var formatted = item;

                if (item.proficiency_id) {
                  var proficiency = lodash.find(vm.state.proficiencies, {
                    value: item.proficiency_id
                  });

                  formatted["level"] = lodash.findIndex(
                    vm.state.proficiencies,
                    {
                      value: item.proficiency_id
                    }
                  );

                  formatted["proficiency_label"] = proficiency
                    ? proficiency.label
                    : "";
                } else {
                  formatted["proficiency_id"] = null;
                }

                if (vm.state.mode === "review_skills") {
                  var expected = getProficiencyLabel(
                    item.expected_proficiency_id
                  );

                  formatted["expected_proficiency_label"] = expected;

                  var declared = getProficiencyLabel(
                    item.declared_proficiency_id
                  );

                  formatted["declared_proficiency_label"] = declared;
                }

                return formatted;
              });
            });

            ngModelCtrl.$parsers.push(function(value) {
              return value.map(function(item) {
                return lodash.pick(item, [
                  "id",
                  "category_id",
                  "proficiency_id",
                  "select_id",
                  "user_created",
                  "not_applicable",
                  "label"
                ]);
              });
            });

            ngModelCtrl.$render = function() {
              vm.state.createdSkills = ngModelCtrl.$viewValue.filter(function(
                item
              ) {
                return item.user_created;
              });

              vm.state.selectedSkills = ngModelCtrl.$viewValue.filter(function(
                item
              ) {
                return !item.user_created;
              });

              vm.state.combinedSkills = vm.state.requiredSkills.concat(
                  vm.state.selectedSkills.concat(vm.state.createdSkills)
              );
            };

            $document.on("click", function(e) {
              var hasParent = angular.element(e.target).parents('.skillset-manager');
              if (hasParent.length > 0) {
                return;
              }
              $timeout(function() {
                vm.closeDropdown();
              });
            });
          }

          vm.ngModelCtrl = ngModelCtrl;
          vm.handleKeyPress = handleKeyPress;
          vm.handleMouseOver = handleMouseOver;
          vm.handleMouseLeave = handleMouseLeave;
          vm.handleNA = handleNA;
          vm.handleProficiency = handleProficiency;

          // function handleWatch(newVal, oldVal) {
          //     $('.search-result-text').each(function (index) {
          //         var input = vm.state.searchInput;
          //         var original = $(this).html();
          //         console.log('original: ', original);
          //         var replacement = original.replace(new RegExp(`/${input}/`), `<strong>${input}</strong>`);
          //
          //         console.log('replacement:', replacement);
          //         $(this).html(replacement);
          //     })
          // }

          function handleKeyPress(e) {
            var key = e.key.toLowerCase();
            var filteredLength = vm.state.filteredSkills.length - 1;
            var filteredIds = lodash.map(vm.state.filteredSkills, "select_id");
            var currentHighlight = filteredIds.indexOf(vm.state.highlighted);
            var nextHighlight;

            switch (key) {
              case "enter":
                e.preventDefault();
                var currentSkill = lodash.find(vm.state.filteredSkills, {
                  select_id: vm.state.highlighted
                });
                vm.selectSkill(currentSkill);
              case "arrowup":
                nextHighlight = currentHighlight - 1;
                break;
              case "arrowdown":
                nextHighlight = currentHighlight + 1;
                break;
              default:
                return;
            }

            var inBound = nextHighlight >= 0 && nextHighlight <= filteredLength;

            if (!inBound) return;

            vm.highlightSkill(filteredIds[nextHighlight]);
            var active = $("#skill-search-dropdown .active");
            var highlighted = key === "arrowup" ? active.prev() : active.next();
            return highlighted.get(0).scrollIntoView({
              behavior: "smooth",
              block: "nearest",
              inline: "end"
            });
          }

          function handleMouseOver(tooltip, $index, $event) {
            vm.setProficiencyTooltip(tooltip, $index);
            var currentTarget = $($event.currentTarget);
            var rowItems = currentTarget.parents(".selectors").children();

            var currentValue = parseInt(currentTarget.data("value"), 10);

            rowItems.each(function(index) {
              var item = $(this);
              var icon = item.children("i").first();

              if (index <= currentValue) {
                toggleIcon(icon, true);
              } else {
                toggleIcon(icon, false);
              }
            });
          }

          function handleMouseLeave(skill, $event) {
            vm.closeProficiencyTooltip();
            var level = skill ? skill.level : -1;
            var currentTarget = $($event.currentTarget);
            var buttons = currentTarget.find("button");

            return resetIcons(buttons, level);
          }

          function handleProficiency(skill, level) {
            vm.toggleProficiency(skill, level);
          }

          function handleNA(skill, $event, label) {
            vm.toggleProficiency(skill, null, label);
            var level = -1;
            var currentTarget = $($event.currentTarget);
            var siblingRow = currentTarget.prev();
            var buttons = siblingRow.children("button");

            return resetIcons(buttons, level);
          }

          function resetIcons(buttons, level) {
            buttons.each(function(index) {
              var icon = $(this)
                .children()
                .first();
              if (level >= index) {
                toggleIcon(icon, true);
              } else {
                toggleIcon(icon, false);
              }
            });
          }

          function toggleIcon(icon, state) {
            if (state) {
              icon.removeClass("fa-circle-thin");
              icon.addClass("fa-circle");
            } else {
              icon.removeClass("fa-circle");
              icon.addClass("fa-circle-thin");
            }
          }

          function getProficiencyLabel(id) {
            if (!id) return "-";

            var target = vm.state.proficiencies.filter(function(item) {
              return item.value === id;
            });

            if (target.length > 0) return target[0].label;
          }
        }
      }
    };
  }

  function rmsSkillsetManagerCtrl(lodash, GenericModel) {
    var vm = this;
    this.$onInit = function() {
      vm.state = {
      loading: false,
      no_result: false,
      mode: vm.options.options.mode,
      config: null,
      proficiencies: vm.options.options.proficiencies,
      dropdownActive: false,
      searchInput: "",
      highlighted: null,
      searchResults: [],
      requiredSkills: [],
      selectedSkills: [],
      createdSkills: [],
      combinedSkills: [],
      filteredSkills: [],
      previous: [],
      searchRequestInstance: null,
      searchModelOptions: lodash.get(vm.options, 'options.searchModelOptions', {
        debounce: 600
      }),
      proficiencyTooltip: {
        row: -1,
        text: "Level"
      }
    };

      vm.openDropdown = openDropdown;
      vm.closeDropdown = closeDropdown;
      vm.handleSearch = handleSearch;
      vm.filterSearch = filterSearch;
      vm.clearSearch = clearSearch;
      vm.selectSkill = selectSkill;
      vm.highlightSkill = highlightSkill;
      vm.removeSkill = removeSkill;
      vm.updateSkills = updateSkills;
      vm.toggleProficiency = toggleProficiency;
      vm.setProficiencyTooltip = setProficiencyTooltip;
      vm.closeProficiencyTooltip = closeProficiencyTooltip;

      init();

    }

    function init() {
      vm.state.config = getOptions(vm.state.mode);
      // console.log(vm.state.config);
      prepareSearchEndpoint();
    }

    function openDropdown() {
      vm.state.dropdownActive = true;
      if (vm.state.filteredSkills.length > 0) {
        highlightSkill(vm.state.filteredSkills[0].select_id);
      }

    }

    function closeDropdown() {
      vm.state.dropdownActive = false;
    }

    function handleSearch(e) {
      var retain = e && e.type === "click";
      vm.state.dropdownActive = true;
      if (vm.state.searchInput.length > 0)
        return filterSearch(vm.state.searchInput, retain);
      return closeDropdown();
    }

    function formatResults(data, input, retain) {
      var selected = vm.state.selectedSkills;
      var deduped = lodash.differenceBy(data, selected, "label");
      var labels = lodash.map(deduped, function(item) {
        return item.label.toLowerCase();
      });
      var exactMatch = lodash.filter(labels, function(label) {
        return label === input.toLowerCase();
      });

      var exactMatchSelected = lodash.filter(selected, function(_selected) {
        return _selected.label.toLowerCase() === input.toLowerCase();
      });

      // vm.state.filteredSkills[0]["hidden"] = exactMatch.length > 0;
      var result = retain ? deduped : sort(deduped, input);
      if ((exactMatch.length == 0) && (exactMatchSelected.length == 0)) {
        result = [new Skill(input)].concat(result);
      }
      return result;
    }

    function filterSearch(input, retain) {
      console.log('filtersearch retain', retain, input);
      if (retain) {
        // var previous = vm.state.filteredSkills.splice(1);
        vm.state.filteredSkills = formatResults(vm.state.previous, input, retain);

        openDropdown();
      } else {
        requestSearch(input);
      }
    }

    function requestSearch(input) {
      vm.state.no_result = false;
      vm.state.loading = true;
      resetSearchResult();
      if (!vm.search_resource) {
        vm.state.filteredSkills.unshift(new Skill(input));

        vm.state.loading = false;
        return;
      }
      vm.state.previous.length = 0;

      if (!!vm.state.searchRequestInstance) {
        vm.state.searchRequestInstance.$cancelRequest();
      }

      vm.state.searchRequestInstance = vm.search_resource[vm.search_method]({
        query: input
      });

      vm.state.searchRequestInstance.$promise.then(function(res) {
        resetSearchResult();
        var results = res.data;
        if (results.length > 0) {
          vm.state.previous = results;
        } else {
          vm.state.no_result = true;
        }
        var formatted = formatResults(vm.state.previous, input);
        // vm.state.filteredSkills.unshift(new Skill(input));
        vm.state.filteredSkills = vm.state.filteredSkills.concat(formatted);
        vm.state.loading = false;
        openDropdown();
        vm.state.searchRequestInstance = null;
      });
    }

    function sort(data, input) {
      return matchSorter.default(data, input, {
        keys: ["label"]
      });
    }

    function clearSearch() {
      vm.state.searchInput = "";
      vm.state.no_result = false;
      resetSearchResult();
      vm.state.previous.length = 0;
      return closeDropdown();
    }

    function resetSearchResult() {
      vm.state.filteredSkills.length = 0;
    }

    function highlightSkill(select_id) {
      vm.state.highlighted = select_id;
    }

    function selectSkill(skill) {
      var isDupe =
        lodash.findIndex(vm.state.combinedSkills, { label: skill.label }) >= 0;

      // if (skill.user_created && !isDupe) {
      //   vm.state.createdSkills.push(skill);
      // }

      if (!isDupe) {
        vm.state.selectedSkills.unshift(angular.copy(skill));
      }

      updateSkills();

      return closeDropdown();
    }

    function removeSkill(skill) {
      var selectedList = vm.state.selectedSkills;
      var createdList = vm.state.createdSkills;

      var selectedPos = selectedList.indexOf(skill);
      var createdPos = createdList.indexOf(skill);

      if (selectedPos !== -1) {
        selectedList.splice(selectedPos, 1);
      } else if (createdPos !== -1) {
        createdList.splice(createdPos, 1);
      }

      return updateSkills();
    }

    function updateSkills() {
      vm.state.combinedSkills = vm.state.requiredSkills.concat(
        vm.state.selectedSkills.concat(vm.state.createdSkills)
      );
      vm.ngModelCtrl.$setViewValue(vm.state.combinedSkills);
    }

    function toggleProficiency(skill, level, label) {
      if (level !== null) {
        skill.proficiency_id = vm.state.proficiencies[level].value;
        skill.proficiency_label = vm.state.proficiencies[level].label;
        skill.level = level;
        skill.not_applicable = false;
      } else {
        skill.proficiency_id = -1; // -1 required for validation check
        skill.level = -1;
        skill.proficiency_label = label;
        skill.not_applicable = true;
      }

      // clone to trigger $setViewValue..
      var copy = lodash.clone(vm.state.combinedSkills);

      vm.ngModelCtrl.$setViewValue(copy);
    }

    function setProficiencyTooltip(value, row) {
      vm.state.proficiencyTooltip.text = value;
      vm.state.proficiencyTooltip.row = row;
    }

    function closeProficiencyTooltip() {
      return (vm.state.proficiencyTooltip.row = -1);
    }

    function prepareSearchEndpoint() {
      // var url = lodash.get(vm.opt)
      if (!vm.search_resource) {
        var url = lodash.get(vm.options, "options.search.url", null);

        vm.search_resource = url ? new GenericModel(url) : null;
        vm.search_method = lodash.get(
          vm.options,
          "options.search.method",
          "query"
        );
      }
    }

    function Skill(input) {
      this.id = null;
      this.label = input;
      this.proficiency_id = null;
      this.select_id = Date.now();
      this.category_name = null;
      this.category_id = null;
      this.user_created = true;
      this.not_applicable = false;
    }

    function Config(options) {
      this.showSearch = options.showSearch;
      this.showRemove = options.showRemove;
      this.showReview = options.showReview;
      this.showDivider = options.showDivider;
      this.showNA = options.showNA;
    }

    function getOptions(mode) {
      var options = {};
      switch (mode) {
        case "add_skills":
          options.showSearch = true;
          options.showRemove = true;
          options.showReview = false;
          options.showNA = false;
          options.showDivider = false;
          break;
        case "required_skills":
          options.showSearch = false;
          options.showRemove = false;
          options.showReview = false;
          options.showNA = true;
          options.showDivider = false;
          break;
        case "review_skills":
          options.showSearch = false;
          options.showRemove = false;
          options.showReview = true;
          options.showNA = true;
          options.showDivider = true;
          break;
      }
      return new Config(options);
    }
  }
})();
